import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'fi-main-menu-change-compact-mode',
    templateUrl: './change-compact-mode.component.html',
    styleUrls: ['./change-compact-mode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChangeCompactModeComponent implements OnInit {
    @Input() isCompactMode: boolean = false;
    @Output() isCompactModeChange = new EventEmitter<boolean>();

    constructor() {}

    ngOnInit() {}

    changeClick($event: Event) {
        $event.preventDefault();
        this.isCompactMode = !this.isCompactMode;
        this.isCompactModeChange.emit(this.isCompactMode);
    }
}
